import type { StateCreatorEnhance } from '@halo/zustand-enhance';
import { createEnhance } from '@halo/zustand-enhance';
import axios from 'axios';
import { updateInfoStorage } from '@/configs/storages';

export type UpdateInfo = {
  updateFlag: string;
};

export interface UpdateStore {
  updateInfo: UpdateInfo | undefined;
  getUpdateInfo: () => Promise<UpdateInfo | undefined>;
  runUpdate: () => Promise<void>;
  runCheckUpdate: () => void;
}

const updateStoreCreator: StateCreatorEnhance<UpdateStore> = (set, get) => ({
  updateInfo: undefined,
  getUpdateInfo: async () => {
    const updateInfo: UpdateInfo = await axios('/update.json', {
      params: { t: Date.now() },
    }).then((res) => res.data);
    const updateFlag = await updateInfoStorage.getItem('updateFlag');

    if (updateFlag !== updateInfo.updateFlag) {
      return updateInfo;
    }
  },
  runUpdate: async () => {
    const { getUpdateInfo } = get();
    const updateInfo = await getUpdateInfo();
    if (updateInfo) {
      updateInfoStorage.setItem('updateFlag', updateInfo.updateFlag);
    }
  },
  runCheckUpdate: () => {
    const { getUpdateInfo } = get();
    setInterval(
      async () => {
        const updateInfo = await getUpdateInfo();
        if (updateInfo) {
          set({ updateInfo });
        }
      },
      2 * 60 * 1000
    );
  },
});

export const useUpdateStore = createEnhance(updateStoreCreator);

if (!import.meta.env.DEV) {
  const { runUpdate, runCheckUpdate } = useUpdateStore.getState();
  await runUpdate();
  runCheckUpdate();
}
